export { default as HistogramWidget } from "./histogram_widget";
export { default as WidgetEditHistogram } from "./histogram_widget_form";

import * as HistogramWidgetFactory from "./histogram_widget_factory";

export { HistogramWidgetFactory };
